import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';

import { Area } from '@commons/models/domain/Area';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-area-item-list',
  templateUrl: './area-item-list.component.html',
  styleUrls: ['./area-item-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AreaItemListComponent),
      multi: true,
    }
  ],
})
export class AreaItemListComponent implements ControlValueAccessor {

  @Output() public onClick$: EventEmitter<Area> = new EventEmitter();
  @Output() public onClickName$: EventEmitter<Area> = new EventEmitter();
  @Output() public onEdit$: EventEmitter<Area> = new EventEmitter();
  @Output() public onDelete$: EventEmitter<Area> = new EventEmitter();

  @Input() public data: Area;

  public checked: boolean;

  public onChange: any = () => {};
  public onTouch: any = () => {};

  constructor() { }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(checked: boolean): void {
    this.checked = checked;
  }

  public onModelChange(e: boolean): void {
    this.checked = e;
    this.onChange(e);
  }

}
